if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();
      this.shareButton = this.querySelector('button.share-button__button');
      this.desktopPopup = this.querySelector('.share-button__desktop-popup');
      this.urlInput = this.querySelector('.share-button__url-input');
      this.copyButton = this.querySelector('.share-button__copy-button');
      
      // Format URL to use www.indieovation.com
      const currentUrl = this.urlInput ? this.urlInput.value : document.location.href;
      this.urlToShare = this.formatUrl(currentUrl);

      // Update input with formatted URL
      if (this.urlInput) {
        this.urlInput.value = this.urlToShare;
      }

      // Close popup when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.desktopPopup.classList.remove('active');
        }
      });

      this.shareButton.addEventListener('click', (e) => {
        e.stopPropagation();
        if (navigator.share && window.innerWidth <= 749) {
          // Use native share on mobile
          navigator.share({
            url: this.urlToShare,
            title: document.title
          });
        } else {
          // Show desktop popup
          this.desktopPopup.classList.toggle('active');
        }
      });

      this.copyButton.addEventListener('click', () => {
        navigator.clipboard.writeText(this.urlToShare).then(() => {
          // Visual feedback for copy success
          const originalColor = this.copyButton.querySelector('.icon-clipboard').style.fill;
          this.copyButton.querySelector('.icon-clipboard').style.fill = '#4CAF50';
          setTimeout(() => {
            this.copyButton.querySelector('.icon-clipboard').style.fill = originalColor;
          }, 1000);
        });
      });
    }

    formatUrl(url) {
      // Replace myshopify.com domain with www.indieovation.com
      return url.replace(/\/\/[^\/]+/, '//www.indieovation.com');
    }

    updateUrl(url) {
      this.urlToShare = this.formatUrl(url);
      if (this.urlInput) {
        this.urlInput.value = this.urlToShare;
      }
    }
  });
}
